import { combineReducers } from 'redux';
import { BillingAction, BillingActionType } from '../../actions/billingActions';

const loading = (state = false, action: BillingAction) => {
  switch (action.type) {
    case BillingActionType.GET_PLANS:
      return true;
    case BillingActionType.GET_PLANS_OK:
    case BillingActionType.GET_PLANS_ERROR:
      return false;
    default:
      return state;
  }
};

export default combineReducers({
  loading,
});
